<script setup lang="ts">
import investors from './investors.json'

const { t } = useI18n()

</script>

<script lang="ts">
export default {
  name: 'WhoWeAreInvestments'
}
</script>

<template>
  <section class="flex flex-col items-center lg:py-90 lg:px-90 py-56 px-24">
    <div class="max-w-[940px] ">
      <div class="flex flex-col lg:flex-row items-center justify-between gap-40 lg:gap-56">
        <p class="lg:max-w-[380px] body-1-m lg:hl-2-m">
          {{ t('title') }}
        </p>

        <div class="flex flex-col lg:grid lg:grid-cols-2 gap-12 w-full">
          <div
            v-for="investor in investors"
            :key="investor.alt"
            class="px-60 bg-gray2-400 w-full h-[84px] lg:h-[140px] flex items-center justify-center rounded-24">
            <img
              :src="investor.logo"
              :alt="investor.alt">
          </div>
        </div>
      </div>

      <div class="w-full h-[1px] bg-pine-200 my-56 lg:my-72" />

      <div class="flex flex-col lg:flex-row items-center justify-between gap-32">
        <p class="lg:display-6 display-7 text-pine-600 lg:max-w-[520px]">
          {{ t('member.title') }}
        </p>

        <div>
          <img
            :src="t('member.image')"
            :alt="t('member.alt')"
            class="h-[58px] lg:h-[70px]">
        </div>
      </div>
    </div>
  </section>
</template>
<i18n src="./i18n.json" lang="json"></i18n>
